import { InquiryDto } from '../../models/Inquiry.dto';
import BaseApi from './BaseApi';

/**
 * 問い合わせ一覧取得API。
 */
class GetInquiryListApi extends BaseApi {
  async get(data: { userId: string } | { companyId: string }) {
    return await this.execute('athomeGetInquiryList', {
      method: 'POST',
      body: data
    }).then(({ result }) => result as InquiryDto[]);
  }
}

export default GetInquiryListApi;
